// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5c-0";
export var eligibilityCardNotEligible = "_5c-1";